import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    TextField,
    Autocomplete,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom'; // <-- add this import

// StyledTextField (unchanged)
const StyledTextField = ({ label, align = 'left', ...props }) => {
    const theme = useTheme();
    const inputBoxStyle = {
        "& .MuiOutlinedInput-root": {
            borderRadius: theme.borderRadius?.medium || 8,
            backgroundColor: theme.palette?.lightgray?.main || "#F3F4F6",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            "& fieldset": {
                borderColor: theme.palette?.gray?.main || "#D1D5DB",
            },
            "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-focused": {
                backgroundColor: theme.palette?.light?.main || "#ffffff",
                "& fieldset": {
                    borderColor: theme.palette.primary.main,
                },
            },
            "& input": {
                textAlign: align,
            },
        },
    };

    return (
        <Box>
            {label && (
                <Typography variant="boddyText1" sx={{ mb: 0.5 }}>
                    {label}
                </Typography>
            )}
            <TextField size="small" fullWidth sx={inputBoxStyle} {...props} />
        </Box>
    );
};
const StyledAutocomplete = ({ label, options = [], ...props }) => {
    const theme = useTheme();
    const inputBoxStyle = {
        "& .MuiOutlinedInput-root": {
            borderRadius: theme.borderRadius?.medium || 8,
            backgroundColor: theme.palette?.lightgray?.main || "#F3F4F6",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            "& fieldset": {
                borderColor: theme.palette?.gray?.main || "#D1D5DB",
            },
            "&:hover fieldset": {
                borderColor: theme.palette.primary.main,
            },
            "&.Mui-focused": {
                backgroundColor: theme.palette?.light?.main || "#ffffff",
                "& fieldset": {
                    borderColor: theme.palette.primary.main,
                },
            },
        },
    };

    return (
        <Box>
            {label && (
                <Typography variant="bodyText1" sx={{ mb: 0.5 }}>
                    {label}
                </Typography>
            )}
            <Autocomplete
                options={options}
                renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth sx={inputBoxStyle} />
                )}
                {...props}
            />
        </Box>
    );
};



const VacantPopup = ({
    roomNo = "STD-101",
    roomType = "Standard",
    dueCheckIn = "DD-MM-YYYY",
    onClose,
    onSave,
    maintenance = 0,
    statusInfo = ""
}) => {
    const navigate = useNavigate(); // <-- initialize navigate

    const handleViewMore = () => {
        // You can pass a reservation ID as query or route param
        navigate(`/reservation`);
    };
    const [housekeepingStatus, setHousekeepingStatus] = useState(statusInfo)

    return (
        <Box
            sx={{

                p: 2.5,
                bgcolor: 'light.main',
                borderRadius: 2,
                boxShadow: 3,
                display: 'flex',
                flexDirection: 'column',
                maxWidth: "400px",
                gap: 2,
            }}
        >
            {/* Header */}
            <Box display="flex" alignItems="center">
                <Typography>
                    Maintenance Issue : {maintenance}
                </Typography>
                {/* <Button
                    // onClick={handleViewMore}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        textTransform: 'none',
                        padding: 0,
                        minWidth: 'auto',
                    }}
                >
                    <Typography variant="subHeading" color="primary">
                        View More
                    </Typography>
                    <ArrowForwardIcon fontSize="small" />
                </Button> */}
            </Box>

            {/* Room Details */}
            <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
                <StyledTextField label="Room No." value={roomNo} InputProps={{ readOnly: true }} />
                <StyledTextField label="Room Type" value={roomType} InputProps={{ readOnly: true }} />
            </Box>

            {/* Due Check-in */}
            {/* <Box display="flex" justifyContent="center" alignItems="center"  mt={1}>
                <Typography variant="buttonL">Due Check-in :</Typography>
                <Typography variant="buttonL" color="blue.main">{dueCheckIn}</Typography>
            </Box> */}

            {/* Housekeeping Status */}
            <StyledAutocomplete
                label="Housekeeping Status"
                value={housekeepingStatus}
                options={["Dirty", "Clean", "Inspect", "Room Care"]}
                onChange={(e, newValue) => setHousekeepingStatus(newValue)}
                defaultValue="Clean"
                fullWidth
                slotProps={{
                    paper: {
                        sx: {
                            '& .MuiAutocomplete-option:hover': {
                                backgroundColor: '#E1EFFF!important', // <-- custom hover color
                            },
                        },
                    },
                }}
            />

            {/* Footer Buttons */}
            <Box display="flex" justifyContent="flex-end" mt={1} gap={1}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        borderRadius: 2,
                        minWidth: 126,
                        textTransform: 'none',
                        border: '2px solid var(--Primary-Blue-MB, rgba(39, 57, 77, 1))'
                    }}
                >
                    Close
                </Button>
                <Button
                    variant="contained"
                    onClick={() => onSave(housekeepingStatus)}
                    sx={{ borderRadius: 2, textTransform: 'none', minWidth: 150 }}
                >
                    Save
                </Button>
            </Box>
        </Box>
    );
};

export default VacantPopup;
